import { ServiceAccount } from '@shared/models';

export const serviceAcccountMock: ServiceAccount = {
  createdBy: {
    id: 'b3e96829-12ec-4a6e-8923-6716089386db',
    type: 'kor_employee',
  },
  createdAt: '2024-09-05T16:47:59.624474Z',
  updatedBy: {
    id: 'b3e96829-12ec-4a6e-8923-6716089386db',
    type: 'kor_employee',
  },
  updatedAt: '2024-09-05T16:47:59.624474Z',
  id: '5aa67f3b-575a-4d90-af42-d99d107bc535',
  parentId: 'aeb1b131-046b-4453-ba3f-601d7c86a2b4',
  shortId: 'jboqnt@kor.rocketkorsa.net',
  name: 'Test',
  roles: [
    {
      id: 'e8681d2d-165d-4423-a949-eb4bf34a32f9',
      name: 'View Only',
    },
  ],
  serviceAccountStatus: 'ACTIVE',
};
